import { useState, useMemo } from 'react';
import { units } from '../../../mocks/units';

export default function Availability() {
  const [filterType, setFilterType] = useState<string>('all');
  const [filterStatus, setFilterStatus] = useState<string>('all');

  const filteredUnits = useMemo(() => {
    return units.filter((unit) => {
      const matchesType = filterType === 'all' || unit.type === filterType;
      const matchesStatus = filterStatus === 'all' || unit.status === filterStatus;
      return matchesType && matchesStatus;
    });
  }, [filterType, filterStatus]);

  const uniqueTypes = Array.from(new Set(units.map((u) => u.type)));

  return (
    <section id="disponibilidade" className="bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="mb-12">
          <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black mb-4">
            Tabela de Unidades
          </h2>
          <p className="text-gray-600 text-lg">
            Confira a disponibilidade atualizada das unidades do ATMOS
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <div className="flex-1">
            <label htmlFor="filter-type" className="block text-sm font-medium text-gray-700 mb-2">
              Filtrar por Tipologia
            </label>
            <select
              id="filter-type"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary cursor-pointer text-sm"
            >
              <option value="all">Todas as Tipologias</option>
              {uniqueTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="flex-1">
            <label htmlFor="filter-status" className="block text-sm font-medium text-gray-700 mb-2">
              Filtrar por Status
            </label>
            <select
              id="filter-status"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary cursor-pointer text-sm"
            >
              <option value="all">Todos os Status</option>
              <option value="Disponível">Disponível</option>
              <option value="Vendido">Vendido</option>
            </select>
          </div>
        </div>

        {/* Results Count */}
        <div className="mb-6">
          <p className="text-gray-600 text-sm">
            Exibindo <strong>{filteredUnits.length}</strong> de <strong>{units.length}</strong> unidades
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto bg-white rounded-2xl shadow-sm border border-gray-200">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Unidade
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Tipologia
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Área (m²)
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Pé Direito
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredUnits.map((unit, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">
                    {unit.unit}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {unit.type}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {unit.area}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {unit.ceiling}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        unit.status === 'Disponível'
                          ? 'bg-green-100 text-green-700'
                          : 'bg-gray-100 text-gray-700'
                      }`}
                    >
                      {unit.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Quer saber valores e condições especiais?
          </p>
          <a
            href="https://wa.me/5541988674555?text=Olá! Quero receber a tabela completa de valores e disponibilidade do ATMOS."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-[#25D366] hover:bg-[#20BA5A] text-white px-8 py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-xl"></i>
            <span>Receber Tabela Completa</span>
          </a>
        </div>
      </div>
    </section>
  );
}
